import React, { useState, useEffect } from "react";
import { GET_DATA_URL } from "../utils/Constants";
import { fetchDataFromURL } from "../utils/Util";

const Table = (props) => {
    const { isin, language, T } = props;
    const [tableData, setTableData] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchDataFromURL(`${GET_DATA_URL}?ISIN=${isin}&LANGUAGE=${language}`);
                const tData = response.quote;
                setTableData(tData);
                // console.log("Data fetched: ", tData);
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };

        try {
            document.querySelector('h2').insertAdjacentHTML('beforeend', '<sup class="maFootnote jsFootnote"><a href="#footnote01">[2]</a></sup>');
            document.body.style.margin = "0";
            document.querySelectorAll('.maStyle16c').forEach(element => {
                element.style.padding = "2px 10px";
            });
            const parentUrl = document.referrer;
            if (parentUrl.indexOf("dev.horizonsetfs") < 0) {
                setTimeout(() => {
                    window.location.reload();
                }, 60000);
            }
        } catch (err) {
            console.error(err);
        }

        fetchData(); // Initial fetch
    }, [isin, language]);

    const renderRow = (rowData, isHeader = false, isFirstRow = false) => (
        <tr>
            {isHeader ? (
                <th className="label">{T[rowData.rowHeader] ? T[rowData.rowHeader] : rowData.rowHeader}</th>
            ) : (
                <td className="label no-border"  style={{ paddingTop: isFirstRow ? "10px" : "0" }}>
                    {T[rowData.rowHeader] ? T[rowData.rowHeader] : rowData.rowHeader}
                </td>
            )}
            {rowData.rowValues.map((value, index) => (
                isHeader ? (
                    <th key={index} className="right-align">
                        {T[value]}
                    </th>
                ) : (
                    <td key={index} className="right-align">
                        $ {value}
                    </td>
                )
            ))}
        </tr>
    );
    const inputDate = tableData.date;
    const date = new Date(inputDate);
    // Format to 'YYYY年M月D日'
    const formattedDate = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;

    return (
        <body style={{ background: "none", textAlign: "left" }}>
        <div className="fund-detail">
            <div className="market-prices multi-currency" id="market-prices">
                <div className="header">
                    <h3>
                        <span className="capitalize">{T[tableData.title]}</span>
                        <sup className="maFootnote jsFootnote">{tableData.superscript}</sup>
                        <small className="txtleft">{T['AS_OF']}{language === "en" ? ` ${tableData.date}` : formattedDate}</small>
                    </h3>
                </div>
                <div className="post-content">
                    <table>
                        <thead>
                        {tableData.headers && renderRow(tableData.headers[0], true)}
                        </thead>
                        <tbody>
                        {tableData.previousClose && renderRow(tableData.previousClose[0], false, true)}
                        {tableData.morning && renderRow(tableData.morning[0])}
                        {tableData.afternoon && renderRow(tableData.afternoon[0])}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        </body>
    );
}

export default Table;